import { Tag } from '@playq/octopus-common';

export const checkTagPresent = (tags: Tag[], key: string, value?: string) =>
  tags.some((tag) => {
    if (tag.key !== key) return false;
    if (value && tag.value !== value) return false;
    return true;
  });
